module.exports = __webpack_public_path__ + "static/media/smiling.57db0ad8.svg";